
/**
 * FR CA resource file

 */

export const labels = {
	title: "Données financières d'EY Canvas",
	status: 'État',
	header: 'En-tête',
	canvas: 'Canvas',
	canvasEconomics: "Données financières d'EY Canvas",
	badRequest: 'demande erronée',
	errorBanner: '{0} erreur(s)',
	userProfileDropdown: {
		myProfile: 'Mon profil',
		signOut: 'Se déconnecter'
	},
	clientCode: 'Code client',
	hours: 'Heures',
	local: 'Locale',
	currency: 'Devises',
	rate: 'Taux',
	forecast: 'Prévision',
	variance: 'Écart',
	edit: 'Modifier',
	arrowUp: 'Flèche vers le haut',
	budget: 'Budget',
	priorBudget: 'Budget précédent',
	currentBudget: 'Budget actuel',
	summary: 'Sommaire',
	actual: 'Réel',
	priorActual: 'Réel précédent',
	currentActual: 'Réel courant',
	remaining: 'Restant',
	adjustment: 'Ajustement',
	estimate: 'Estimation',
	isRequired: 'Le champ {0} est requis',
	isPositiveInteger: 'Le champ {0} est requis et doit contenir un nombre entier non négatif.',
	isPositiveDecimal: 'Le champ {0} est requis et doit contenir un nombre positif à 2 décimales.',
	in: 'Pour',
	id: 'Identifiant',
	currentYear: 'Exercice considéré',
	priorYear: 'Exercice précédent',
	budgetHierarchy: 'Hiérarchie du budget',
	executionBudgetHierarchy: "Hiérarchie du budget relatif à l'exécution",
	noContentAvailable: 'Aucun contenu disponible',
	viewMore: 'Afficher plus',
	budgetExecutionPhase: 'Budget pour tous les objets contenus dans {0}',
	details: 'détails',
	unallocated: 'Non affecté',
	none: 'Aucun',
	thousands: 'Milliers',
	millions: 'Millions',
	lakhs: 'Lakhs',
	crores: 'Crores',
	budgetObjectName: "Nom de l'objet budget",
	editActivityCodes: "Modifier les codes d'activité",
	save: 'Enregistrer',
	send: 'Envoyer',
	cancel: 'Annuler',
	searchActivityCodes: "Rechercher des codes d'activité",
	noActivityCodesAvailable: "Aucun code d'activité disponible",
	select: 'Sélectionner',
	engagementCode: 'Code mission',
	engagementCodeName: 'Nom du code mission',
	activityCode: "Code d'activité",
	activityCodeDescription: "Description du code d'activité",
	searchActivityCodesPlaceholderText: "Rechercher des codes d'activité",
	addMember: 'Ajouter un membre',
	closeLabel: 'Fermer',
	cancelLabel: 'Annuler',
	seachInputRequired: 'Entrer le texte recherché',
	nameOrEmail: 'Nom ou courriel',
	emailForExternal: 'Adresse courriel',
	noRecord: 'Aucun résultat trouvé',
	userSearchPlaceholder: 'Entrer le nom ou l’adresse courriel et appuyer sur la touche Entrée pour afficher les résultats',
	userSearchPlaceholderForExternal: 'Entrer l’adresse courriel et appuyer sur la touche Entrée pour afficher les résultats',
	clearAllValues: 'Effacer toutes les valeurs',
	clear: 'Effacer',
	inValidEmail: 'Veuillez entrer une adresse courriel valide',
	invalidClientCode: 'Code client invalide',
	railSearchText: 'Rechercher',
	open: 'Ouvrir',
	remove: 'Supprimer',
	leave: 'Quitter',
	delete: 'Supprimer',
	markAsCompleted: 'Indiquer comme étant terminé',
	budgetedHours: 'Heures budgétées',
	forecastedHours: 'Heures prévues',
	actualHours: 'Heures réelles',
	ftaVariance: 'Écart entre les prévisions et les données réelles',
	ftaVarianceTooltip: 'Écart entre les prévisions et les données réelles',
	usedHours: 'Heures utilisées',
	etcHours: "Nombre d'heures estimé avant l'achèvement?",
	createProjectCard: 'Créer un projet',
	plusClients: '+{0} clients',
	plusCodes: '+{0} codes client',
	clientNames: 'Noms de client :',
	clientName: 'Nom du client :',
	clientNameLabel: 'Nom du client',
	clientCodes: 'Codes client :',
	clientCodeCard: 'Code client :',
	financialAnalysis: 'Analyse financière',
	billingExpenses: 'Facturation et dépenses',
	independence: 'Indépendance',
	timeChargedCanvasIndependenceStatus: 'Statut d’indépendance du projet global par code financier et code EY Canvas',
	independenceStatusFromCanvasLabel: 'Statut dʼindépendance dʼEY Canvas',
	independenceRequired: 'Indépendance requise',
	validatedCanvas: 'Validé dans EY Canvas',
	notInvited: 'Non invité',
	notApplicable: 'Sans objet',
	incomplete: 'Incomplète',
	other: "Autre",
	financialCodesDisplayed: "Codes financiers affichés",
	independenceStatusChangeReasonLabel: "Modifier le statut",
	independenceStatusChangeReasonDescription: "Sélectionner la raison pour laquelle le statut a été changé à Terminé pour le membre de lʼéquipe sélectionné",
	changeReasonLabel: 'Raison',
	clarificationLabel: 'Précision (facultatif)',
	characterCount: '{0} de 200 caractères',
	expandAll: "Tout développer",
	collapseAll: "Tout réduire",
	canvasEngagements: "Missions EY Canvas",
	independenceCompleted: "Confirmation d'indépendance remplie",
	engagementName: 'Nom de la mission',
	engagementIndependenceStatus: "Par statut d'indépendance pour la mission",
	noAssociatedClients: 'Aucun client associé',
	noCanvasEngagementsIdentified: 'Aucune mission EY Canvas identifiée',
	placeholderForSearch: "Chercher un membre de l'équipe",
	exportToExcel: 'Exporter vers Excel',
	all: 'Tous',
	updateSelected: 'Mise à jour sélectionnée',
	updateAll: 'Tout mettre à jour',
	customizeTable: 'Personnaliser le tableau',
	canvasEngagementName: 'Nom de la mission EY Canvas',
	displayBy: 'Afficher les données par',
	financialDetails: 'Données financières',
	actualHoursToDate: "Heures réelles jusqu'à présent",
	byWeekEndingDate: 'selon la date du dernier jour de la semaine',
	ClickAndDrag: "Cliquez sur une zone dans l'organigramme et faites-la glisser pour effectuer un zoom avant",
	etc: "Délai d'exécution estimé",
	auditProgress: 'Audit progress',
	tasksAndMilestones: 'Tâches et jalons',
	milestonesOverdue: 'Jalons en retard',
	milestoneOverdue: 'jalons en retard',
	inProgress: 'En cours',
	inReview: 'En cours de revue',
	Complete: 'Terminée',
	assignments: 'Affectations',
	assignment: 'affectations',
	assignmentsOverdue: 'Affectations en retard',
	assignmentOverdue: 'affectations en retard',
	overdue: 'en retard',
	requestOverdue: 'Demande en retard',
	requestsOverdue: 'demandes en retard',
	total: 'Total',
	complete: 'Terminée',
	closed: 'Fermées',
	Unassigned: 'Non attribuée',
	unassigned: 'non assignée',
	sent: 'Envoyée',
	totalTask: 'Nombre total de tâches',
	collaboration: 'Collaboration',
	received: 'Reçue',
	accepted: 'Acceptée',
	outstanding: 'En cours',
	unsentDrafts: 'Ébauches non envoyées',
	draft: 'Projet',
	drafts: 'projets',
	returned: 'retournées',
	draftRequests: 'rédiger des demandes',
	percent: 'Pourcentage',
	preparer: 'Préparateur',
	reviewer: 'Responsable de la revue',
	NoDataForSelectedOptions: 'Aucune information disponible pour les options sélectionnées',
	NoAssignmentDataForSelectedOptions: "La mission n'utilise pas la fonction d'attribution",
	NoCollabDataForSelectedOptions: "La fonction de collaboration n'est pas utilisée pour cette mission",
	tasks: 'Tâches',
	totalTasks: 'tâches totales',
	requests: 'demandes',
	requestSent: 'demandes envoyées',
	requestsSent: 'Demandes envoyées',
	expandDetails: 'Afficher plus de détails',
	onlyProjectAdministratorsCanEdit: 'Seuls les administrateurs de projet peuvent modifier',
	onlyProjectAdministratorsCanDelete: 'Seuls les administrateurs de projet peuvent supprimer les projets',
	userOptions: "Options de l'utilisateur",
	userOptionsDropdown: {
		userSettings: "Paramètres de l'utilisateur",
		delegateAccess: 'Gérer les délégués',
		privacyNotice: 'Avis sur la protection des données à caractère personnel',
		signOut: 'Se déconnecter'
	},
	delegateToInstruction: "Attribuez des droits d'accès à vos collègues, afin qu'ils puissent valider les codes de mission en votre nom. Les délégués sélectionnés pourront valider tous les codes de mission auxquels vous avez accès.",
	delegateFromInstruction: "Les utilisateurs suivants ont délégué leurs droits d'accès pour la validation des codes de mission.",
	delegateAccess: 'Gérer les délégués',
	addDelegates: 'Ajouter des délégués',
	addAnother: 'Ajouter un nouveau délégué',
	hideMyDelegate: 'Masquer mes délégués',
	showMyDelegate: 'Afficher mes délégués',
	duplicateUser: "Cette personne a déjà les droits d'accès",
	informationRequired: 'Cette information est requise',
	delegateTo: 'Délégué à',
	delegateFrom: 'Délégué par',
	noDelegatesAdded: "Aucun délégué n'a été ajouté.",
	noDelegationReceived: "Aucun droit d'accès n'a été reçu.",
	removeDelegateMessgae: "Voulez-vous vraiment retirer cette personne de la liste de vos délégués? Une fois qu'elle aura été retirée de la liste, elle ne pourra plus valider de codes de mission en votre nom.",
	removeDelegateTitle: 'Retirer un délégué',
	delegate: 'Déléguer',
	saveAndClose: 'Enregistrer et fermer',
	resetZoom: 'Réinitialiser le zoom',
	exportData: 'Exporter des données',
	rankCode: "Code de l'échelon",
	userGui: "Identificateur unique mondial (GUI) de l'utilisateur",
	email: 'Adresse courriel',
	globalAnsr: 'ANSR mondial',
	globalCost: 'Coût mondial',
	globalMargin: 'Marge mondiale',
	localAnsr: 'ANSR local',
	localCost: 'Coût local',
	localMargin: 'Marge locale',
	weekEnding: 'Dernier jour de la semaine',
	welcomeToEconomics: "Bienvenue dans le module Données financières d'EY Canvas",
	adminPortal: 'portail administratif',
	home: 'Accueil',
	enterFirstNameText: "Saisissez le prénom, le nom de famille ou l'adresse courriel de l'utilisateur et appuyez sur Entrée pour rechercher",
	addBtn: 'Ajouter',
	cancelBtn: 'Annuler',
	close: 'Fermer',
	selectRole: 'Rôle',
	upsText: 'Oups!',
	sufficientRightsToAccess: 'Vous ne disposez pas des droits requis pour accéder à cette page.',
	detailedInformation: 'Les informations détaillées peuvent différer des données sommaires présentées en raison du délai de synchronisation des données pour les rendre disponibles.',
	noResultFound: 'Les critères de recherche ne donnent aucun résultat.',
	loading: 'Chargement en cours…',
	search: 'Rechercher',
	softwareUpdate: 'Mises à jour logicielles',
	updateLater: 'Mettre à jour plus tard',
	updateNow: 'Mettre à jour maintenant',
	updateMsg: "Des mises à jour logicielles sont disponibles pour le module Données financières d'EY Canvas. Sélectionnez Mettre à jour maintenant pour télécharger et installer les mises à jour. La page sera actualisée.",

	eycanvasEngagements: 'Missions EY Canvas',
	eycanvasEngagement: 'Mission EY Canvas',
	expandView: 'Développer lʼaffichage',
	noFinancialCodesDisplay: 'Aucun code financier à afficher',
	expand: 'Développer',
	collapse: 'Réduire',
	bulkSendIndependenceLabel: "Envoi en bloc des confirmations d'indépendance",
	independenceStatusInviteUserLabel: "Ajouter un membre à l'équipe interne avec la restriction Indépendance seulement",
	independenceStatusInviteUserDescription: "Définir le rôle du membre de l'équipe ci-après. Cet utilisateur sera ajouté à la mission EY Canvas {0} avec la restriction Indépendance seulement et recevra une notification lui demandant de remplir le formulaire sur l'indépendance.",
	clickToInviteUser: "pour envoyer la confirmation d'indépendance",
	click: 'Cliquer',
	invitePending: 'Invitation en attente',
	engagementRolePlaceholder: 'Rôle dans la mission',
	engagementRoleRequiredErrorMessage: "Veuillez indiquer le rôle dans la mission pour le membre de l'équipe sélectionné",
	engagementInvitationSuccessToastMessage: "Vous avez bien envoyé la ou les confirmations d'indépendance.",
	engagementInvitationFailureToastMessage: "Échec de l'envoi de la ou des confirmations d'indépendance. Veuillez réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
	independenceInviteConfirmationMessage: "La confirmation d'indépendance a bien été envoyée. En attente d'une réponse.",
	engagementRoleRequiredOverAllErrorMessage: "Un rôle dans la mission n'a pas été sélectionné pour un ou plusieurs utilisateurs. Sélectionner le rôle dans la mission à partir du menu déroulant pour procéder à l'envoi de la confirmation d'indépendance.",
	administrativeContractor: 'Administrative contractor',
	notAvailable: 'Not Available',
	allocation: 'Allocation'
};

export const errors = {
	default: "Une erreur s'est produite. Veuillez communiquer avec le Service de dépannage.",
	102: 'Projet invalide',
	106: 'Autorisation RBAC refusée.',

	1001: 'Utilisateur introuvable.',
	1002: "Échec de l'appel de récupération de tous les utilisateurs.",
	1003: "L'identificateur unique mondial (GUI) de l'utilisateur ne peut pas être nul.",
	1004: 'La demande ne peut être nulle.',
	1005: "L'utilisateur n'a pas pu être créé, car un utilisateur avec le même identificateur unique mondial (GUI) existe déjà.",
	1006: "Plus d'un utilisateur avec le même identificateur unique mondial (GUI) a été trouvé.",
	1007: "L'utilisateur n'est pas un membre actif. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",
	1008: "Le format des nombres sélectionné n'est pas valide. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",
	1009: "Le format du nombre arrondi sélectionné n'est pas valide. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",
	1010: "Le format de la devise sélectionné n'est pas valide. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",
	1011: "Le format de la date sélectionné n'est pas valide. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",
	1012: "La langue sélectionnée n'est pas valide. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",
	1013: 'Le prénom est trop court ou trop long. Veuillez réessayer.',
	1014: 'Le nom de famille est trop court ou trop long. Veuillez réessayer.',
	1015: "Le format des nombres négatifs sélectionné n'est pas valide. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",
	1016: "L'utilisateur ne peut pas être mis à jour, car il n'existe pas.",
	1017: "Une erreur s'est produite pendant la récupération des préférences de l'utilisateur. Échec de l'appel de l'interface de programmation.",
	1018: "Une erreur s'est produite lors de la création de l'utilisateur. Échec de l'appel de l'interface de programmation.",
	1019: "'Une erreur s'est produite lors de la mise à jour des préférences de l'utilisateur. Échec de l'appel de l'interface de programmation.",
	1020: "L'utilisateur n'est pas un membre actif. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
	1021: "La valeur du thème sélectionnée n'est pas valide. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
	1022: "La valeur de la devise sélectionnée n'est pas valide. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
	1023: "L'utilisateur n'est pas autorisé à retirer le membre de l'équipe requis du projet.",
	1024: "Une erreur s'est produite lors de la création de l'utilisateur délégué. Échec de l'appel de l'interface de programmation.",
	1025: 'La liste des utilisateurs délégués ne doit pas être vide.',
	1026: "Le nom d'un utilisateur est trop long ou trop court.",
	1027: "L'identificateur unique mondial (GUI) d'un utilisateur est invalide.",
	1028: "L'adresse courriel d'un utilisateur est trop longue ou trop courte.",
	1029: "Le champ de l'identifiant de l'utilisateur ne doit pas être vide.",
	1030: "Le champ du nom de l'utilisateur ne doit pas être vide.",
	1031: "Le champ de l'adresse courriel de l'utilisateur ne doit pas être vide.",
	1032: "L'utilisateur ne figure pas dans la liste des délégués ayant les droits pour supprimer l'accès.",
	1033: "L'utilisateur ne figure pas dans la liste des personnes ayant attribué des droits pour supprimer l'accès.",
	1034: "L'utilisateur fait déjà partie des délégués de la collection.",
	1035: "La longueur de l'identifiant de l'utilisateur n'est pas appropriée. Veuillez réessayer avec le bon identifiant de l'utilisateur.",
	1036: "L'utilisateur connecté ne peut pas faire partie de la liste. Veuillez réessayer plus tard.",
	1040: "Vous ne disposez pas des droits d'administrateur. Veuillez communiquer avec le Service de dépannage.",

	7001: "Échec de l'appel des métadonnées relatives aux missions.",
	7006: "Vous ne pouvez pas accéder à EY Canvas pour le moment. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",

	8003: 'Error while getting Engagement Details from CDS API.',
	8006: "Vous ne pouvez pas accéder à EY Canvas pour le moment. Veuillez actualiser la page et réessayer. Si l'erreur persiste, veuillez communiquer avec le Service de dépannage.",
	8004: "Code mission introuvable. S'il s'agit d'un code Mercury, assurez-vous que le type de mission est inclus. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
	8007: "Une erreur s'est produite lors de la récupération des renseignements sur la mission à partir de l'interface de programmation CDS.",
	8008: 'Connection failed. Refresh and try again. If the issue persists, contact the Help desk.',

	9001: 'La requête ne peut pas être nulle',
	9002: 'Le champ Code client du projet ne peut être vide',
	9003: 'Le champ Nom du projet ne peut pas être vide.',
	9004: 'Le champ Pourcentage ne peut pas être vide.',
	9005: 'Le champ Taux ne peut pas être vide.',
	9006: "Le budget n'est associé à aucune mission sélectionnée.",
	9007: "L'identifiant unique de la mission ne peut pas être nul.",
	9008: "Le nom du client d'audit ne peut pas être nul.",
	9009: 'La description de la mission ne peut pas être nulle.',
	9010: "L'identifiant unique du client d'audit ne peut pas être nul.",
	9011: 'Le système de mission associé ne peut pas être nul.',
	9012: "L'identifiant unique de la mission associée ne peut pas être nul.",
	9013: 'Le nom de la mission associée ne peut pas être nul.',
	9014: "L'identifiant unique du client d'audit associé ne peut pas être nul.",
	9015: "Le nom du client d'audit associé ne peut pas être nul.",
	9016: 'La mission associée ajoutée par ne peut pas être nulle.',
	9017: 'Une ou plusieurs missions Canvas sont invalides.',
	9018: 'Un ou plusieurs codes missions associés sont invalides.',
	9019: "Les pourcentages des projets doivent être supérieurs à zéro.",
	9020: "Les pourcentages des projets ne peuvent pas compter plus de deux décimales.",
	9021: "Les taux des projets doivent être supérieurs à zéro.",
	9022: "L'identifiant du projet est invalide.",
	9023: "Échec de la récupération des données de l'analyse financière.",
	9024: 'Renseignements sur le projet introuvables.',
	9025: "Échec de la demande de récupération de l'en-tête.",
	9026: 'Les critères de recherche ne donnent aucun résultat.',
	9027: 'Type de regroupement non valide.',
	9028: "L'utilisateur actuel n'a pas accès au projet.",
	9029: 'Renseignements sur la facturation du projet introuvables.',
	9030: "Filtres relatifs aux données financières du projet introuvables.",
	9031: "Le nom d'un utilisateur est trop long ou trop court.",
	9032: "L'identificateur unique mondial (GUI) d'un utilisateur est invalide.",
	9033: "L'adresse courriel d'un utilisateur est trop longue ou trop courte.",
	9034: "Au moins un membre de l'équipe devrait avoir un rôle d'administrateur de projet.",
	9035: "Vous êtes le dernier administrateur actif du projet. Supprimez le projet pour le retirer de votre page d'accueil. Si vous ne pouvez pas le supprimer, veuillez communiquer avec le Service de dépannage.",
	9036: 'Veuillez retirer une ou plusieurs missions Canvas. Le nombre dépasse la quantité maximale permise de {0}.',
	9037: "Veuillez retirer certains membres de l'équipe, car le nombre dépasse la quantité maximale permise ({0} membres).",
	9038: 'Veuillez retirer certains codes de mission, car le nombre dépasse la quantité maximale permise ({0} codes).',
	9039: "Le nombre d'utilisateurs pour le projet doit être supérieur à zéro.",
	9040: 'Les chaînes de codes financiers non validés ne doivent pas être nulles ou vides et leur longueur ne doit pas dépasser 50 caractères.',
	9041: "Le champ de l'identifiant du projet ne doit pas être vide.",
	9042: "Suppression impossible. Veuillez réessayer et si l'erreur persiste, communiquez avec le Service de dépannage.",
	9043: "L'utilisateur actuel n'a pas les droits pour modifier le projet.",
	9044: 'Project Financial Details call failed.',
	9045: "L'état du projet n'est pas valide.",
	9046: "L'état de l'utilisateur du projet n'est pas valide.",
	9047: "Le rôle de l'utilisateur du projet est invalide.",
	9048: 'Le nom du projet ne doit pas dépasser 500 caractères.',
	9049: "Le champ du prénom de l'utilisateur ne peut pas être vide.",
	9050: "Le champ du nom de l'utilisateur ne peut pas être vide.",
	9051: "Le champ de l'identifiant global unique (GUI) de l'utilisateur ne peut pas être vide.",
	9052: "Le champ de l'adresse courriel de l'utilisateur ne peut pas être vide.",
	9053: "Le champ de l'indicateur de l'utilisateur Administrateur ne peut pas être vide.",
	9054: "Le compte d'un utilisateur privilégié ne peut pas être ajouté comme utilisateur du projet.",
	9055: 'Filtres relatifs aux dépenses du projet introuvables.',
	9056: 'Project indepedence patch request body cannot be empty.',
	9058: 'Les codes financiers sont invalides.',
	9063: "Champ justification pour la confirmation d'indépendance invalide.",
	9064: "Champ type pour la confirmation d'indépendance invalide.",
	9065: 'Filtres relatifs aux dépenses du projet introuvables.',
	9066: "Le nombre d'identifiants de mission associés au projet dépasse le nombre maximal permis.",
	9067: 'Opération de correction invalide',
	9068: "Un utilisateur a déjà modifié l'état, veuillez actualiser la page pour afficher l'état le plus récent.",
	9069: 'Independence patch API failed.',
	9070: 'Codes financiers en double associés à la mission EY Canvas',
	9071: 'Seuls les codes financiers uniques associés à la mission EY Canvas peuvent être désignés comme code principal.',
	9072: 'Les codes financiers principaux associés aux missions EY Canvas sont invalides.',
	9073: 'Codes financiers non validés en double',
	9074: 'Utilisateurs en double',
	9075: "L'adresse courriel de l'utilisateur est invalide.",
	9076: "Le corps de la demande de création de l'utilisateur de la mission ne peut pas être vide.",
	9077: "La demande de création de l'utilisateur de la mission contient des utilisateurs en double.",
	9078: "Le rôle de l'utilisateur de la mission est invalide.",
	9079: 'Mission EY Canvas invalide',
	9080: "La mission n'est pas mappée à ce projet.",
	9081: "Échec de la demande de création de l'utilisateur de la mission.",
	9082: "La session est expirée pour cause d'inactivité. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

	/*Admin error codes*/
	14001: 'Utilisateur introuvable',
	14002: "Échec de l'appel de l'utilisateur Administrateur",
	14003: "L'utilisateur Administrateur trouvé est inactif",
	14004: "Échec de la création de l'utilisateur Administrateur",
	14005: 'Le prénom est trop court ou trop long. Veuillez réessayer.',
	14006: 'Le nom de famille est trop court ou trop long. Veuillez réessayer.',
	14007: "L'identifiant du rôle d'administrateur est invalide.",
	14008: "L'utilisateur sélectionné est déjà un administrateur. Veuillez vérifier.",
	14009: "Échec de la demande de recherche de l'utilisateur Administrateur.",
	14010: "L'identificateur unique mondial (GUI) de l'utilisateur ne peut pas être vide.",
	14011: "L'identificateur unique mondial (GUI) de l'utilisateur doit être supérieur à zéro.",
	14012: "L'identifiant de l'utilisateur n'est pas valide. Veuillez réessayer.",
	14013: "L'adresse courriel n'est pas valide. Veuillez réessayer.",
	14014: "L'utilisateur connecté n'est pas l'utilisateur Administrateur",
	14015: "Échec de l'appel de recherche de projet de l'administrateur",
	14016: "L'utilisateur Administrateur existe déjà, mais il est inactif.",
	14017: "L'administrateur ne peut être qu'un compte d'utilisateur privilégié.",
	14018: "Le champ de l'identifiant du rôle d'administrateur ne peut pas être vide.",
	14019: "L'utilisateur connecté n'est pas l'administrateur du système.",
	14020: 'Compte privilégié du demandeur invalide.',
	14021: "L'administrateur ne peut être qu'un compte d'utilisateur privilégié.",
	14023: "Erreur pendant la suppression des rôles d'administrateur existants.",
	14024: "Erreur pendant l'ajout de rôles d'administrateur mis à jour.",
	14025: "Le champ de l'identifiant de l'utilisateur Administrateur ne peut pas être vide.",

	/*PAANS error codes*/
	15001: "Le service de rédaction des directives d'EY, d'approbation et de notification n'est pas disponible pour le moment. Nous ne sommes pas en mesure de confirmer si toutes les directives pertinentes sont prêtes. Si vous n'avez pas revu les directives pertinentes, actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage."
};
export const roundingOptions = [{
		value: 'none',
		label: 'aucun'
	},
	{
		value: 'thousands',
		label: 'En milliers'
	},
	{
		value: 'millions',
		label: 'En millions'
	},
	{
		value: 'lakhs',
		label: 'En lakhs'
	},
	{
		value: 'crores',
		label: 'En crores'
	}
];

export const displayLanguages = [{
		displayLanguageId: 1,
		label: 'Anglais',
		value: 'en-us'
	},
	{
		displayLanguageId: 4,
		label: 'Français',
		value: 'fr-ca'
	},
	{
		displayLanguageId: 5,
		label: 'Espagnol',
		value: 'es'
	},
	{
		displayLanguageId: 7,
		label: 'Portugais',
		value: 'pt-br'
	},
	{
		displayLanguageId: 8,
		label: 'Japonais',
		value: 'ja'
	},
	{
		displayLanguageId: 9,
		label: 'Mandarin – Chine',
		value: 'zh-cn'
	},
	{
		displayLanguageId: 10,
		label: 'Mandarin – Taïwan',
		value: 'zh-tw'
	},
	{
		displayLanguageId: 11,
		label: 'Hébreu',
		value: 'he'
	},
	{
		displayLanguageId: 12,
		label: 'Coréen',
		value: 'ko'
	}
];

export const numberFormats = [{
		value: '1,234,567,890',
		label: 'numbericStlye1',
		title: '1,234,567,890'
	},
	{
		value: '1.234.567.890',
		label: 'numbericStlye3',
		title: '1.234.567.890'
	},
	{
		value: '1,23,45,67,890',
		label: 'numbericStlye7',
		title: '1,23,45,67,890'
	},
	{
		value: '1 234 567 890',
		label: 'numbericStlye2',
		title: '1 234 567 890'
	}
];

export const dateFormats = [{
		value: 'MM/dd/yyyy',
		label: 'MM/DD/YYYY'
	},
	{
		value: 'dd/MM/yyyy',
		label: 'DD/MM/YYYY'
	},
	{
		value: 'yyyy/MM/dd',
		label: 'YYYY/MM/DD'
	}
];

export const negativeNumberFormats = [{
		value: '(1.1)',
		label: '(1.1)'
	},
	{
		value: '-1.1',
		label: '-1.1'
	},
	{
		value: '- 1.1',
		label: '- 1.1'
	},
	{
		value: '1.1-',
		label: '1.1-'
	},
	{
		value: '1.1 -',
		label: '1.1 -'
	}
];

export const currencyFormats = [{
		value: 'mondial',
		label: 'Mondial'
	},
	{
		value: 'local',
		label: 'Local'
	}
];

export const themeOptions = {
	light: 'Clair',
	dark: 'Sombre'
};

export const currencyOptions = {
	global: 'Mondiale',
	local: 'Locale'
};

export const currencyDisplayOptions = [{
		value: 'Global',
		label: 'Mondial'
	},
	{
		value: 'Local',
		label: 'Local'
	}
];

export const statusValues = [{
		isActive: true,
		label: 'Actif'
	},
	{
		isActive: false,
		label: 'Inactif'
	}
];

export const financialOptions = {
	serviceLine: 'Gamme de services',
	subServiceLine: 'Sous-gamme de services',
	teamMember: "Membre de l'équipe",
	rank: 'Échelon'
};

export const roles = {
	1: 'Associé responsable',
	2: 'Associé responsable de la mission',
	3: 'Directeur',
	4: 'Principal/Associé délégué',
	5: "Chef d'équipe senior",
	6: "Chef d'équipe",
	7: 'Comptable senior',
	8: 'Comptable stagiaire',
	9: 'Étudiant stagiaire',
	10: 'Responsable du contrôle qualité de la mission',
	11: 'Autre associé',
	12: 'Groupe PSM – Comptable stagiaire',
	13: 'Services consultatifs (groupe Risque et certification en TI, SCT, Capital humain ou autre)',
	14: 'Fiscalité',
	15: 'Services de soutien aux cadres',
	16: 'Affaires juridiques',
	17: "Responsable du contrôle qualité de l'audit",
	21: "Superviseur de la fonction d'audit interne",
	22: "Personnel de la fonction d'audit interne",
	23: 'Autorité de réglementation',
	24: 'Autre (p. ex., revue de contrôle préalable)',
	25: 'Bureau',
	26: 'Zone',
	27: "Secteur d'activité",
	28: 'National',
	29: 'Mondial',
	30: 'Groupe PSM – Professionnel senior',
	31: "Groupe PSM – Chef d'équipe"
};

export const serviceLines = [{
		value: 0,
		label: 'Toutes les gammes de service'
	},
	{
		value: 1,
		label: 'Consultation'
	},
	{
		value: 2,
		label: 'Certification'
	},
	{
		value: 3,
		label: 'Bureau mondial de la conformité'
	},
	{
		value: 4,
		label: 'SCT'
	},
	{
		value: 5,
		label: 'Fiscalité'
	},
	{
		value: 6,
		label: 'Autre'
	}
];

export const serviceLinesByServiceLineCode = [{
		code: 'Not available',
		label: 'Non disponible'
	},
	{
		code: null,
		label: 'Allocation'
	},
	{
		code: 'ASU',
		label: 'Certification'
	},
	{
		code: 'TAS',
		label: 'Stratégie et transactions'
	},
	{
		code: 'TAX',
		label: 'Fiscalité'
	},
	{
		code: 'ADV',
		label: 'Consultation'
	}
];

export const userRanks = [{
		id: '11',
		name: 'Associé'
	},
	{
		id: '12',
		name: 'Associé'
	},
	{
		id: '13',
		name: 'Associé délégué'
	},
	{
		id: '21',
		name: "Chef d'équipe senior"
	},
	{
		id: '32',
		name: "Chef d'équipe"
	},
	{
		id: '36',
		name: "Chef d'équipe, Fiscalité"
	},
	{
		id: '4',
		name: 'Sous-traitant'
	},
	{
		id: '41',
		name: 'Senior 3'
	},
	{
		id: '42',
		name: 'Senior'
	},
	{
		id: '43',
		name: 'Stagiaire 2'
	},
	{
		id: '44',
		name: 'Stagiaire'
	},
	{
		id: '45',
		name: 'Senior 2'
	},
	{
		id: '46',
		name: 'Stagiaire 3'
	},
	{
		id: '49',
		name: 'Conseiller'
	},
	{
		id: '5',
		name: 'Administrative contractor'
	},
	{
		id: '51',
		name: 'Étudiant stagiaire'
	},
	{
		id: '52',
		name: 'Soutien administratif'
	},
	{
		id: '53',
		name: 'Stagiaire (SBE)'
	},
	{
		id: '55',
		name: 'Responsable administratif'
	},
	{
		id: '56',
		name: 'Admin - senior'
	},
	{
		id: '57',
		name: 'Admin - intermédiaire'
	},
	{
		id: '58',
		name: 'Admin - junior'
	},
	{
		id: '61',
		name: 'Directeur'
	},
	{
		id: '62',
		name: 'Codirecteur'
	},
	{
		id: '63',
		name: 'Directeur adjoint'
	},
	{
		id: '64',
		name: 'Conseilller superviseur'
	},
	{
		id: '65',
		name: 'Conseiller senior'
	},
	{
		id: '66',
		name: 'Conseiller'
	},
	{
		id: 'Not available',
		name: 'Non disponible'
	},
	{
		id: null,
		name: 'Allocation'
	}
];

export const financialAnalysis = {
	noResultFound: 'Aucun résultat pour les options sélectionnées',
	allServiceLines: 'Toutes les gammes de service',
	allSubServiceLines: 'Toutes les sous-gammes de service',
	allMembers: 'Tous les membres',
	allAvailable: 'Tous les membres disponibles',
	allAdded: 'Tous les membres ajoutés',
	selectAll: 'Tout sélectionner',
	noResult: 'Aucun résultat trouvé',
	noneSelected: 'Aucune sélection',
	clearAllSeleted: 'Effacer la sélection',
	showSelected: 'Afficher la sélection',
	allRanks: 'Tous les échelons'
};

export const independenceStatus = [{
		value: 1,
		label: 'Incomplet – Non invité'
	},
	{
		value: 2,
		label: 'Incomplet – En cours'
	},
	{
		value: 3,
		label: 'Terminé – Autre'
	},
	{
		value: 4,
		label: 'Terminé – Validé dans EY Canvas'
	}
];

export const eycanvasIndependenceStatus = [{
		value: 1,
		label: 'Incomplet'
	},
	{
		value: 2,
		label: "Aucune question n'a été relevée"
	},
	{
		value: 3,
		label: 'Question relevée – Mesure à prendre'
	},
	{
		value: 4,
		label: 'Question résolue – Accès refusé'
	},
	{
		value: 5,
		label: 'Question résolue – Accès accordé'
	},
	{
		value: 6,
		label: 'Sans objet'
	},
	{
		value: 7,
		label: 'Restauré'
	},
	{
		value: 8,
		label: 'Écraser'
	},
	{
		value: 9,
		label: "Précédent ‒ Aucune question n'a été relevée"
	},
	{
		value: 10,
		label: 'Précédent ‒ Question relevée – Mesure à prendre'
	},
	{
		value: 11,
		label: 'Précédent ‒ Question résolue – Accès accordé'
	},
	{
		value: 12,
		label: 'Précédent ‒ Question résolue – Accès refusé'
	}
];

export const eycanvasIndependenceStatusAvailableOnUI = [{
		value: 1,
		label: 'Incomplet'
	},
	{
		value: 2,
		label: "Aucune question n'a été relevée"
	},
	{
		value: 3,
		label: 'Question relevée – Mesure à prendre'
	},
	{
		value: 4,
		label: 'Question résolue – Accès refusé'
	},
	{
		value: 5,
		label: 'Question résolue – Accès accordé'
	},
	{
		value: 6,
		label: 'Sans objet'
	},
	{
		value: 7,
		label: 'Restauré'
	},
	{
		value: 8,
		label: 'Écraser'
	},
	{
		value: 9,
		label: "Précédent ‒ Aucune question n'a été relevée"
	},
	{
		value: 11,
		label: 'Précédent ‒ Question résolue – Accès accordé'
	},
	{
		value: 12,
		label: 'Précédent ‒ Question résolue – Accès refusé'
	},
	{
		value: 13,
		label: 'Not Invited'
	}
];

export const availableUserRoles = [{
		value: 1,
		label: 'Associé responsible',
		displayOrder: 9
	},
	{
		value: 2,
		label: 'Associé responsable de la mission',
		displayOrder: 8
	},
	{
		value: 3,
		label: 'Associé délégué',
		displayOrder: 5
	},
	{
		value: 4,
		label: 'Principal',
		displayOrder: 6
	},
	{
		value: 5,
		label: "Chef d'équipe senior",
		displayOrder: 4
	},
	{
		value: 6,
		label: "Chef d'équipe",
		displayOrder: 3
	},
	{
		value: 7,
		label: 'Professionnel senior',
		displayOrder: 2
	},
	{
		value: 8,
		label: 'Stagiaire',
		displayOrder: 1
	},
	{
		value: 10,
		label: 'Responsable de la revue de la qualité de la mission',
		displayOrder: 10
	},
	{
		value: 11,
		label: 'Autre associé',
		displayOrder: 7
	},
	{
		value: 12,
		label: 'Groupe PSM - Membre du personnel',
		displayOrder: 13
	},
	{
		value: 16,
		label: 'Directeur des affaires juridiques',
		displayOrder: 12
	},
	{
		value: 17,
		label: "Responsable de la revue de la qualité de l'audit",
		displayOrder: 11
	},
	{
		value: 30,
		label: 'Groupe PSM – Professionnel senior',
		displayOrder: 14
	},
	{
		value: 31,
		label: "Groupe PSM – Chef d'équipe",
		displayOrder: 15
	}
];

export const employmentStatusFilter = [{
		value: 'A',
		label: 'Actif'
	},
	{
		value: 'L,P,U',
		label: 'Congé autorisé'
	},
	{
		value: 'D,R,T',
		label: "Fin d'emploi"
	}
];

export const employmentStatus = [{
		value: 'A',
		label: 'Actif'
	},
	{
		value: 'D',
		label: "Fin d'emploi"
	},
	{
		value: 'L',
		label: 'Congé autorisé'
	},
	{
		value: 'T',
		label: "Fin d'emploi"
	},
	{
		value: 'P',
		label: 'Congé autorisé'
	},
	{
		value: 'R',
		label: "Fin d'emploi"
	},
	{
		value: 'U',
		label: 'Congé autorisé'
	}
];

export const independenceStatusDropdown = [{
		label: 'Incomplet',
		options: [{
				value: 1,
				label: 'Incomplet – Non invité'
			},
			{
				value: 2,
				label: 'Incomplet – En cours'
			}
		]
	},
	{
		label: 'Terminé',
		options: [{
				value: 3,
				label: 'Terminé – Autre'
			}
		]
	}
];

export const customizedTableOptions = [{
		id: 2,
		label: "Statut d'indépendance dans EY Canvas"
	},
	{
		id: 3,
		label: 'Société membre'
	},
	{
		id: 4,
		label: 'Pays'
	},
	{
		id: 5,
		label: 'Heures facturées'
	},
	{
		id: 6,
		label: "Statut d'indépendance global"
	},
	{
		id: 7,
		label: 'Date de confirmation'
	},
	{
		id: 8,
		label: "Situation d'emploi"
	},
	{
		id: 9,
		label: 'Mis à jour par'
	},
	{
		id: 10,
		label: 'Date de mise à jour'
	}
];

export const independenceStatusChangeReasons = [{
		value: 1,
		label: 'Traité en dehors dʼEY Canvas ‒ Aucune question relevée',
		isDisplayed: true
	},
	{
		value: 7,
		label: 'Traité en dehors dʼEY Canvas ‒ Questions relevées',
		isDisplayed: true
	},
	{
		value: 8,
		label: 'Traité en dehors dʼEY Canvas ‒ Questions réglées',
		isDisplayed: true
	},
	{
		value: 2,
		label: 'Personne toujours visée',
		isDisplayed: true
	},
	{
		value: 3,
		label: 'A quitté la Société',
		isDisplayed: true
	},
	{
		value: 4,
		label: 'Congé autorisé',
		isDisplayed: true
	},
	{
		value: 5,
		label: "Fin d'emploi",
		isDisplayed: false
	},
	{
		value: 6,
		label: 'Autre',
		isDisplayed: false
	}
];

export const common = {
	selected: 'Sélectionnée',
	cancel: 'Annuler',
	checkbox: {
		selectAllOn: 'Tout sélectionner',
		selectAllOff: 'Tout désélectionner'
	},
	clear: 'Effacer',
	close: 'Fermer',
	nav: {
		projectName: 'Nom du projet'
	},
	pagination: {
		show: 'Afficher',
		iconHover: {
			first: 'Première page',
			previous: 'Page précédente',
			next: 'Page suivante',
			last: 'Dernière page'
		}
	},
	search: {
		clear: 'Effacer la recherche',
		buttonTitle: 'Rechercher',
		placeholder: 'Rechercher',
		noResultsPlaceholder: 'Aucun résultat trouvé'
	},
	table: {
		remove: 'Supprimer',
		noDataPlaceholder: 'Aucune donnée disponible',
		noResultsPlaceholder: 'Aucun résultat trouvé'
	},
	toggleSwitch: {
		no: 'Non',
		yes: 'Oui'
	},
	wizard: {
		next: 'Continuer',
		back: 'Retour',
		finish: 'Terminer'
	},
	unsavedChanges: 'Changements non enregistrés',
	unsavedChangesDescription: 'Si vous continuez, les changements non enregistrés seront perdus. Voulez-vous vraiment annuler vos changements?'
};

export const project = {
	myProjects: 'Mes projets',
	priorProjects: 'Projets précédents',
	searchForBudgets: 'Rechercher',
	emptyContainer: "Vous n'avez aucun budget actif. Veuillez cliquer sur «Créer un budget» pour commencer.",
	noResultsFound: 'Aucun résultat trouvé.',
	create: {
		title: 'Créer un projet',
		clientCode: 'Code client',
		clientCodeInfo: 'Les codes miroirs ne sont pas reconnus. Veuillez utiliser le code généré par le système (c.-à-d.,  Mercury ou GFIS).',
		clientName: 'Nom du client',
		clientNamePlaceholder: 'Saisir le code client pour chercher un nom de client',
		name: 'Nom du projet',
		rate: 'Taux horaire par défaut',
		rateInfo: 'Le taux horaire par défaut sera utilisé pour calculer la valeur des heures budgétées. Ce taux devrait être calculé en divisant les honoraires à facturer par le total des heures prévues.',
		percentage: 'Pourcentage de réalisation attendu.',
		percentageInfo: 'Le pourcentage de réalisation attendu sera appliqué à la valeur temporelle des heures facturées dans Mercury ou dans le GFIS.',
		relateEngagementsInstructionalText: 'Sélectionner une ou plusieurs missions EY Canvas qui seront utilisées dans ce projet. Les mesures tirées de ces missions seront présentées avec les données financières. Seules les missions actuellement accessibles seront affichées.',
		selectClientAndWorkspaceInstructionalText: 'Sélectionner un client et un espace de travail pour trouver les missions EY Canvas qui seront associées à ce projet.',
		engagementPanelPlaceholder: 'Sélectionner un client et un espace de travail pour afficher les missions suggérées.',
		engagementPanelNoResultsFound: 'Aucun résultat trouvé',
		emptyEngagements: 'Aucune mission EY Canvas disponible. Créer une nouvelle mission dans EY Canvas pour commencer.',
		selectClient: 'Sélectionner un client',
		selectWorkspace: 'Sélectionner un espace de travail',
		selectEngagements: 'Sélectionner une mission',
		selectedEngagements: 'Missions ajoutées',
		selectedEngagementError: 'Sélectionner une ou plusieurs missions pour continuer',
		searchEngagements: 'Rechercher des missions',
		searchUsers: 'Rechercher des utilisateurs',
		engagementLabel: '{0} | Identifiant : {1}',
		addBtn: 'Ajouter',
		removeBtn: 'Supprimer',
		clientLbl: 'Client',
		engagementCodeLbl: 'Code mission',
		engagementTypeCodeLbl: 'Type de mission',
		engagementNameLbl: 'Nom de la mission',
		engagementId: 'Identifiant',
		addedByLbl: 'Ajoutée par',
		engagementDescriptionLbl: 'Description de la mission',
		systemLbl: 'Système',
		noEngagementsLabel: 'Associer des codes mission à ce projet.',
		step4InstTxt: 'Sélectionner un ou plusieurs codes de mission devant être associés au projet.',
		relatedEngagementCodesSubtitle: 'Codes mission associés',
		relatedEngagementCodeLink: 'Associer un code mission de Mercury ou du GFIS. Codes miroirs non reconnus.',
		unauthorizedModalHeader: 'Utilisateur non autorisé',
		unauthorizedText: "Vous n'êtes pas autorisé(e) à associer",
		allowedUsersText: 'Voici la liste des personnes qui sont autorisées à effectuer cette action.',
		closeBtn: 'Fermer',
		validateBtn: 'Valider',
		relatedEngagementAddLabel: 'Associer un code mission de Mercury ou du GFIS. Codes miroirs non reconnus.',
		todayLbl: "Aujourd'hui",
		NoEmailMessage: 'Aucune adresse courriel fournie',
		noEngagementsAdded: 'Aucune mission ajoutée',
		selectToImport: 'Sélectionner une mission EY Canvas pour importer des utilisateurs dans ce projet.',
		addMember: "Si un utilisateur n'est pas actif dans la mission EY Canvas, {0} pour l'ajouter.",
		addedMembers: 'Membres ajoutés',
		employeeName: 'Membre',
		role: 'Rôle',
		manageTeamInstructionalText: "Sélectionnez des membres actifs à partir des missions EY Canvas associées, suivez les instructions ci-après pour ajouter d'autres membres qui ne font pas partie des missions EY Canvas.",
		currentUser: 'Utilisateur actuel',
		canvasEngagements: 'Missions EY Canvas',
		wizardSteps: [{
				stepName: 'Étape 1',
				stepDescription: 'Entrer les détails sur le projet',
				active: true
			},
			{
				stepName: 'Étape 2',
				stepDescription: 'Sélectionner des missions EY Canvas'
			},
			{
				stepName: 'Étape 3',
				stepDescription: "Gérer l'accès",
				relatedEngagementCodesSubtitle: 'Codes mission associés',
				relatedEngagementCodeLink: 'Associer un code mission de Mercury ou du GFIS. Codes miroirs non reconnus.',
				unauthorizedModalHeader: 'Utilisateur non autorisé',
				unauthorizedText: "Vous n'êtes pas autorisé(e) à associer",
				allowedUsersText: 'Voici la liste des personnes qui sont autorisées à effectuer cette action.',
				close: 'Fermer'
			},
			{
				stepName: 'Étape 4',
				stepDescription: 'Se connecter à Mercury/GFIS'
			},
			{
				stepName: 'Step 5',
				stepDescription: 'Associer des codes mission aux missions EY Canvas',
				isExit: true
			}
		],
		ratePerHour: 'Taux horaire',
		realizationPercentage: 'Pourcentage de réalisation'
	},
	stepOne: {
		enterProjectName: 'Entrer un nom de projet pour continuer'
	},
	stepTwo: {
		addCanvasEngagements: 'Ajouter des missions EY Canvas au projet',
		editCanvasEngagements: 'Modifier les missions EY Canvas associées au projet',
		selectCanvasEngagements: 'Les missions EY Canvas auxquelles vous avez accès sont affichées. Choisissez une ou plusieurs missions EY Canvas à inclure au projet.',
		noCanvasEngagements: 'Aucune mission EY Canvas disponible. Passez à la prochaine étape pour créer le projet.',
		noCanvasEngagementsSelected: "Aucune mission EY Canvas n'a été sélectionnée",
		noSearchResultsFoundLeftRail: 'Aucun résultat',
		clientName: 'Client',
		workspace: 'Espace de travail',
		engagementCode: 'Code mission',
		canvasEngagementName: 'Mission EY Canvas',
		changes: 'Modifications',
		tooltipMessages: {
			clientName: 'Nom du client',
			clientCode: 'Code client',
			engagementCode: 'Code mission',
			engagementDescription: 'Nom de la mission',
			workspaceID: "Identifiant de l'espace de travail",
			workspaceDescription: "Nom de l'espace de travail"
		}
	},
	stepThree: {
		editTeamMembers: "Modifier les membres de l'équipe participant au projet",
		editTeamMembersWhoWillHaveAccess: "Modifier les membres de l'équipe qui auront accès au projet. Pour ajouter un membre qui ne participe pas aux missions EY Canvas associées, utilisez la fonction de recherche sur la droite. Les administrateurs de projet auront la possibilité de gérer le projet (p. ex., ajouter ou retirer des membres de l'équipe).",
		addTeamMembers: 'Ajouter des membres au projet',
		addTeamMembersWhoWillHaveAccess: "Ajouter des membres de l'équipe qui auront accès au projet. Pour ajouter un membre qui ne participe pas aux missions EY Canvas associées, utilisez la fonction de recherche sur la droite. Les administrateurs de projet auront la possibilité de gérer le projet (p. ex., ajouter ou retirer des membres de l'équipe).",
		noCanvasEngagementsSelected: "Aucune mission EY Canvas n'a été sélectionnée",
		noSearchResultsFoundLeftRail: 'Aucun résultat',
		addOtherTeamMembers: "Ajouter d'autres membres qui ne font pas partie des missions EY Canvas connectées.",
		member: 'Membre',
		projectAdministrator: 'Administrateur de projet',
		clickHere: 'cliquer ici',
		nameOrEmail: 'Nom ou courriel',
		addNewMember: 'Ajouter',
		firstName: 'Prénom',
		lastName: 'Nom',
		inviteAndClose: "Inviter et fermer''",
		inviteAndAddAnother: 'Inviter et ajouter un autre membre',
		clear: 'Effacer'
	},
	stepFour: {
		engagementCode: 'Code mission',
		clientName: 'Client',
		validation: 'État',
		independenceOnly: 'Indépendance seulement',
		noEngagementCodes: 'Aucun code mission ajouté au projet',
		addNewMember: 'Ajouter',
		addEngagementManually: 'Ajouter des codes mission',
		addEngagementCodes: 'Ajouter des codes mission',
		editEngagementCodes: 'Modifier les codes de mission',
		validateEngagement: "Valider tous les codes mission ajoutés. Seuls les codes missions auxquels vous avez accès dans le GFIS/Mercury peuvent être validés. Si un code mission présente la mention « Indépendance seulement », les détails relatifs à ce code de mission (tels que les membres de l'équipe et les heures facturées qui y sont associées) seront inclus dans le Sommaire de l'information relative à l'indépendance de ce projet dans le module Données financières, mais ils ne seront pas inclus dans les informations financières connexes.",
		informationalMessage: 'Pour Mercury, faites précéder le code mission du type de mission (p. ex., E-12345678)',
		noCanvasEngagements: "Aucune mission EY Canvas n'a été ajoutée au projet",
		engagementCodePlaceholder: 'Entrer le code mission',
		validate: 'Valider',
		engagementCodeRequired: 'Code mission requis',
		searchNoResults: "Aucun résultat trouvé"
	},
	stepFive: {
		title: 'Associer des codes mission à des missions EY Canvas',
		description: "Les codes mission principaux associés à chacune des missions EY Canvas connectées sont affichés ci-après. Pour associer dʼautres codes mission à une mission EY Canvas, utilisez la fonctionnalité glisser-déposer ci-après.",
		financialCodes: {
			searchButtonTitle: 'Rechercher',
			searchButtonPlaceholder: 'Rechercher par code de mission financier',
			header: 'Codes mission',
			noRecords: 'Aucun code mission trouvé',
			canvasEngagements: 'Missions EY Canvas',
			noResults: 'Aucun résultat trouvé'
		},
		canvasEngagements: {
			searchButtonTitle: 'Rechercher',
			clearButtonTitle: 'Effacer',
			noResults: 'Aucun résultat trouvé',
			searchButtonPlaceholder: 'Rechercher par client ou par mission EY Canvas',
			header: 'Clients et missions',
			noRecords: 'Aucune mission EY Canvas associée au projet',
			noEngagementCodes: 'Aucun code mission associé',
			primary: 'Principal',
			displayUnassociatedEngagements: "Afficher les missions EY Canvas auxquelles aucun code financier n'est associé"
		}
	},
	deleteProject: 'Supprimer le projet',
	deleteDescription: 'Voulez-vous vraiment supprimer le projet pour tous les utilisateurs?',
	deleteDescText: 'Cette action ne peut pas être annulée.',
	delete: 'Supprimer',
	cancel: 'Annuler',
	close: 'Fermer',
	confirm: 'Confirmer',
	leaveProject: 'Quitter',
	leaveDescription: 'Voulez-vous vraiment quitter ce projet? Les membres de votre équipe y auront toujours accès.',
	change: 'modification',
	changes: 'modifications'
};

export const users = {
	settings: {
		title: "Paramètres de l'utilisateur",
		firstName: 'Prénom',
		lastName: 'Nom',
		displayLanguage: "Langue d'affichage",
		numberFormat: 'Format des nombres',
		negativeNumberFormat: 'Format des nombres négatifs',
		currencyFormat: 'Format de la devise',
		dateFormat: 'Format de la date',
		roundingFormat: "Format de l'arrondissement",
		save: 'Enregistrer',
		cancel: 'Annuler',
		errorMessageSelect: 'Veuillez sélectionner une valeur.',
		errorMessageInput: 'Veuillez entrer une valeur valide.',
		isRequired: 'est un champ requis',
		preferences: 'Préférences',
		yourDelegates: 'Vos délégués',
		yourDelegatesDescription: 'Utilisateurs que vous avez autorisés à récupérer les données financières associées aux codes mandat auxquels vous avez accès dans Mercury ou le GFIS.',
		delegationsFromOthers: 'Vos accès à titre de délégué',
		delegationsFromOthersDescription: 'Utilisateurs qui vous ont autorisé(e) à récupérer les données financières associées aux codes mandat auxquels ils ont accès dans Mercury ou le GFIS.',
		noUsersIdentified: 'Aucun utilisateur identifié',
		addADelegate: 'Ajouter un délégué',
		theme: 'Thème',
		preferredCurrency: 'Devise à utiliser',
		status: 'État'
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: 'Filtrer les clients',
		filter: 'Filtrer',
		searchPlaceholder: 'Rechercher',
		searchClearHoverText: 'Effacer',
		searchHoverText: 'Rechercher',
		unvalidated: 'Non validé',
		noData: 'Aucune mission EY Canvas associée',
		noResults: 'Aucun résultat trouvé',
		noInformationAvailable: 'Aucune information disponible pour les options sélectionnées',
		independence: 'Indépendance',
	    noDataFound: 'Aucune donnée trouvée'
	},
	roundingType: 'Arrondissement :',
	roundingFormats: {
		none: 'Aucun',
		thousands: 'En milliers',
		millions: 'En millions',
		lakhs: 'En lakhs',
		crores: 'En crores'
	},
	updatedDateType: {
		financialDateLabel: 'Données financières',
		updatedOn: 'mises à jour le',
		canvasDateLabel: 'Donnée EY Canvas'
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: 'TER',
			actualTER: 'TER réel',
			billed: 'Facturés',
			actualBilling: 'Honoraires facturés',
			totalEngagementRevenue: 'Total des revenus tirés de la mission (TER) (honoraires + dépenses)',
			forecastedTER: 'TER prévu'
		},
		margin: {
			margin: 'Marge',
			target: 'Cible'
		},
		globalDeliveryService: {
			gds: 'Recours au groupe PSM',
			globalDeliveryService: 'Prestation de services mondiaux'
		}
	},
	currency: 'Devise :',
	globalCurrency: 'Mondiale',
	localCurrency: 'Locale',
	noDataAvailable: 'Aucune donnée disponible pour les filtres sélectionnés.',
	actualHours: 'Heures réelles',
	etc: "Estimation à l'achèvement",
	ftaVariance: 'Écart entre les prévisions et les données réelles',
	completedTasks: 'Tâches terminées',
	closedAssignments: 'Affectations fermées',
	acceptedRequests: 'Demandes acceptées',
	gDSUsage: 'Recours au groupe PSM',
	summaryHeaderPartner: 'Associé',
	summaryHeaderPpedd: 'Associés, associés délégués ou directeurs',
	summaryHeaderExecutive: 'Cadre',
	financialProgressCard: {
		financialProgress: 'Progrès financiers',
		financialDetails: 'Données financières',
		ansr: 'ANSR',
		nsr: 'NSR',
		ansrTooltip: 'Revenus nets standards rajustés (honoraires nets excluant les dépenses)',
		nsrTooltip: "Revenus nets standards (nombre d'heures aux taux horaires standards individuels)",
		eafTooltip: "Facteur d'ajustement du mandat",
		cost: 'Coût',
		hours: 'Heures',
		expandDetails: 'Afficher plus de détails',
		expand: 'Développer',
		collapse: 'Réduire',
		collapseDetails: 'Réduire les détails',
		margin: 'Marge',
		marginPercentage: 'Marge',
		rphAcronym: 'Taux horaire',
		cphAcronym: 'Coût horaire',
		mphAcronym: 'Marge horaire',
		eafAcronym: 'EAF',
		actual: 'Réel',
		budgeted: 'Budgété',
		forecasted: 'Prévisions',
		ftaVariance: 'Écart entre les prévisions et les données réelles',
		ftaVarianceTooltip: 'Écart entre les prévisions et les données réelles',
		rph: 'Taux horaire',
		cph: 'Coût horaire',
		mph: 'Marge horaire',
		ansrCost: 'NSR/Coût',
		serviceLine: 'Gamme de services',
		subServiceLine: 'Sous-gamme de services',
		teamMember: "Membre de l'équipe",
		totalAnsr: 'NSR total',
		totalCost: 'Total des coûts',
		totalHours: 'Total des heures',
		ansrLabelText: 'Revenus nets standards',
		rank: 'Échelon',
		performanceActuals: 'Données réelles sur le rendement'
	},
	financialAnalysis: {
		show: 'Afficher',
		first: 'Première page',
		last: 'Dernière page',
		previous: 'Précédent',
		next: 'Suivant'
	},
	financialFilters: {
		serviceLine: 'Gamme de services',
		subServiceLine: 'Sous-gamme de services',
		rank: 'Échelon',
		teamMember: "Membre de l'équipe",
		showMore: 'Plus',
		clear: 'Effacer',
		clearAll: 'Tout effacer',
		search: 'Rechercher',
		noResultsPlaceholder: 'Aucun résultat',
		noFiltersAvailable: 'Aucun filtre',
		yes: 'Oui',
		no: 'Non',
		tooltip: 'Filtrer',
		expenseType: 'Type de dépense',
		allocation: 'Allocation'
	},
	billingAndExpenses: {
		title: "Honoraires facturés jusqu'à maintenant",
		forecastedTer: 'TER prévu',
		forecastedTerTooltip: 'Total des revenus tirés de la mission prévus (honoraires + dépenses)',
		forecastedBilling: 'Honoraires prévus',
		collected: 'Recouvrés',
		collectedTooltip: 'Recouvré/Facturé',
		unCollected: 'Impayé',
		unCollectedTooltip: 'Impayé/Facturé',
		billed: 'Billed (Outstanding)',
		billedTooltip: 'Facturé/TER prévu',
		billedTotal: 'Facturé',
		unbilled: 'Non facturés',
		unbilledTooltip: 'Non facturé/TER prévu',
		engagementCode: 'Code mission',
		invoiceDate: 'Date de facturation',
		currency: 'Devise',
		invoiceNumber: 'Numéro de la facture',
		amount: 'Montant',
		noInformationPlaceholder: 'Aucune information disponible pour les options sélectionnées',
		actualTer: 'TER réel',
		actualTerTooltip: 'Total des revenus tirés de la mission (TER) (honoraires + dépenses)',
		actualExpenseToDate: "Dépenses engagées jusqu'à maintenant",
		displayBy: 'Afficher les données par',
		expenseType: 'Type de dépense',
		teamMember: "Membre de l'équipe",
		totalExpenseToDate: "Total des dépenses jusqu'à maintenant",
		expenseTypeColumn: 'Type de dépense',
		teamMemberColumn: "Membre de l'équipe",
		globalExpenseAmount: 'Montant de la dépense − mondial',
		localExpenseAmount: 'Montant de la dépense − local',
		billingSummary: 'Résumé de la facturation',
		billingStatus: 'État de la facturation',
		billingTER: 'TER',
		serviceLine: 'Gamme de services',
		serviceLineColumn: 'Gamme de services',
		rank: 'Échelon',
		rankColumn: 'Échelon',
		allocation: 'Allocation',
		allocationsExpense: 'Allocated expenses present'
	},
	independence: {
		teamMember: "Membre de l'équipe",
		hoursCharged: 'Heures facturées',
		independenceStatus: "Statut d'indépendance global",
		confirmationDate: 'Date de confirmation',
		memberFirm: 'Société membre',
		eyCanvasIndependenceStatus: "Statut d'indépendance dans EY Canvas",
		employmentStatus: "Situation d'emploi",
		country: 'Pays',
		updatedBy: 'Mis à jour par',
		updatedDate: 'Date de mise à jour',
		selectColumns: 'Sélectionner les colonnes',
		confirmationDateBefore: 'Date de confirmation avant',
		confirmationDateAfter: 'Date de confirmation après',
		excelsummary: 'Résumé',
		excelMercury: 'Données provenant de Mercury',
		excelCanvas: 'Données provenant de Canvas',
		name: 'Nom',
		gui: 'Identifiant global unique (GUI)',
		rank: 'Échelon',
		emailAddress: 'Adresse courriel',
		clarification: 'Précision',
		explanation: 'Explication',
		updatedOn: 'Mis à jour le',
		client: 'Client',
		mercuryEngagementCode: 'Code mission de Mercury',
		canvasEngagement: 'Mission Canvas',
		email: 'Adresse courriel',
		reason: 'Raison',
		engagementRole: 'Rôle dans la mission',
		location: 'Emplacement',
		employeeStatus: 'Employee status',
		noResultsPlaceholder: 'Aucun résultat trouvé',
		filter : {
			unassociatedFinancialCodes: 'Codes financiers non associés',
			unassociatedLabel: 'Non associés',
			filterHeader: "Filtre relatif à l'indépendance",
			noFinancialCodeLabel: 'Aucun code financier associé',
			noEngagementLabel: 'Aucune mission EY Canvas associée',
			expandText: 'Développer',
			collapseText: 'Réduire',
			noDataFound: 'Aucune donnée trouvée'
		}
	},
	header:{
		hours: 'Heures',
		actualHours: 'Réelles',
		forecastedHours: 'Prévues',
		variance: 'Écart entre les prévisions et les données réelles',
		other: 'Autre',
		ppedd: 'Associés, associés délégués ou directeurs',
		mgrSrMgr: "Chef d'équipe senior/chef d'équipe",
		partnerHours: "Nombre d'heures de l'associé",
		executiveDirector: 'Associé délégué',
		seniorManager: "Chef d'équipe senior",
		manager: "Chef d'équipe",
		senior: 'Professionnel senior',
		staff: 'Stagiaire',
		intern: 'Étudiant stagiaire',
		billed: 'Facturé :',
		ter: 'TER :',
		forecastedTER: 'TER prévu:',
		margin: 'Marge',
		ansr: 'ANSR',
		cost: 'Coût',
		terSection: 'TER',
		billedSection: 'Facturé',
		forecastedTERSection: 'Prévu',
		forecastedTERSectionForHeader: 'TER prévu',
		completedTasks: 'Tâches terminées',
		completedAssignments: 'Affectations fermées',
		acceptedRequests: 'Demandes acceptées',
		gdsUsage: 'Recours au groupe PSM',
		completedTasksTooltip: 'Terminées',
		totalTasksTooltip: 'Total',
		completedAssignmentsTooltip: 'Fermées',
		totalAssignmentsTooltip: 'Total',
		acceptedRequestsTooltip: 'Acceptées',
		sentRequestsTooltip: 'Envoyées',
		gdsHoursTooltip: 'PSM',
		actualHoursTooltip: 'Heures réelles',
		otherTooltip: 'Autre',
		otherHeaderTooltip: 'Autre',
		ppeddTooltip: 'Associé/associé délégué/directeur',
		mgrSrMgrTooltip: "Chef d'équipe senior/chef d'équipe",
		partnerHoursTooltip: 'Associé/Principal',
		executiveDirectorTooltip: 'Associé délégué/Directeur',
		seniorManagerTooltip: "Chef d'équipe senior",
		managerTooltip: "Chef d'équipe",
		seniorTooltip: 'Professionnel senior',
		staffTooltip: 'Stagiaire',
		internTooltip: 'Étudiant stagiaire',
		varianceTooltip: 'Écart entre les prévisions et les données réelles',
		ansrTooltip: 'Revenus nets standards rajustés (honoraires nets excluant les dépenses)',
		marginTooltip: 'Marge = (ANSR - coût) / ANSR',
		terSectionHover: 'Total des revenus tirés de la mission (TER) (honoraires + dépenses)',
		forecastedTERSectionHover: 'Revenus tirés de la mission - total prévu (honoraires + dépenses)',
		billedSectionHover: 'Montant net réel de la facture',
		gdsUsageHover: 'Utilisation du groupe Prestation de services mondiaux'
	},
	allocationsFilters : [{
			value: 1,
			label: 'Yes'
		}
	]
};

export const exportOptions = {
	buttonText: 'Exportation',
	downloadCSV: 'Télécharger en format CSV',
	downloadJPEG: 'Télécharger en format JPEG',
	downloadPDF: 'Télécharger en format PDF',
	downloadPNG: 'Télécharger en format PNG',
	downloadSVG: 'Télécharger en format SVG',
	downloadXLS: 'Télécharger en format XLS',
	exitFullscreen: 'Quitter le mode plein écran',
	viewFullscreen: 'Afficher en plein écran',
	printChart: "Imprimer l'organigramme"
};

export const adminLabels = {
	adminPortal: 'Administration',
	usersTab: 'Gérer les utilisateurs',
	projectsTab: 'Gérer les projets',
	administrators: 'Gérer les administrateurs'
};

export const projectUserStatus = {
	active: 'Actif',
	inactive: 'Inactif'
};

export const projectUserRoles = {
	defaultUser: 'Utilisateur par défaut',
	projectAdministrator: 'Administrateur de projet'
};

export const projectStatus = {
	active: 'Actif',
	deleted: 'Supprimé'
};

export const administratorRoles = {
	none: 'Aucun',
	adminReader: 'Admin-lecture',
	adminWriter: 'Admin-écriture',
	superAdmin: 'Super-admin'
};

export const addUser = {
	firstName: 'Prénom',
	lastName: 'Nom',
	enterFirstNameText: "Saisissez le prénom, le nom de famille ou l'adresse courriel de l'utilisateur et appuyez sur Entrée pour rechercher",
	selectRole: 'Rôle',
	userRole: "Rôle de l'utilisateur",
	clear: 'Effacer',
	email: 'Adresse courriel',
	role: 'Rôle',
	cancel: 'Annuler',
	addUser: 'Ajouter un utilisateur',
	close: 'Fermer',
	add: 'Ajouter',
	addAdministrator: 'Ajouter un administrateur',
	error1: "L'utilisateur sélectionné fait déjà partie du projet. Veuillez vérifier.",
	error2: "Un compte administrateur ne peut être qu'un compte d'utilisateur privilégié."
};

export const adminManageProjects = {
	manageProjects: 'Gérer les projets',
	description: 'Rechercher un projet par son identifiant',
	projectId: 'Identifiant du projet',
	search: 'Rechercher',
	clearSearch: 'Effacer',
	enterValidProject: 'Entrer un identifiant de projet valide',
	projectDetails: 'Détails du projet',
	enterProjectName: 'Entrer le nom du projet',
	projectName: 'Nom du projet',
	projectStatus: 'État du projet',
	financialCodes: 'Codes financiers',
	noFinancialCodes: "Aucun code de mission financier n'est mappé à ce projet",
	engagementCode: 'Code mission',
	client: 'Client',
	status: 'État',
	validatedBy: 'Validé par',
	canvasEngagements: 'Missions EY Canvas',
	canvasEngagement: 'Mission EY Canvas',
	noCanvasEngagements: 'Aucune mission EY Canvas mappée à ce projet',
	member: 'Membres',
	gui: 'Identifiant global unique (GUI)',
	firstName: 'Prénom',
	lastName: 'Nom',
	emailAddress: 'Adresse courriel',
	userRole: "Rôle de l'utilisateur",
	validated: 'Validé',
	unvalidated: 'Non validé',
	enterValidGui: "Entrer un identificateur unique mondial (GUI) valide pour l'identifiant du projet",
	requiredProjectName: 'Le champ du nom de projet ne peut pas être vide',
	successToastMessage: 'Modifications bien enregistrées',
	resetToastMessage: 'Réinitialisation terminée',
	errorToastMessage: 'Au moins un membre du projet doit être un administrateur de projet. Veuillez vérifier les modifications.',
	independenceOnly: 'Indépendance seulement',
	yes: 'Oui',
	no: 'Non'
};

export const manageAdministrators = {
	title: 'Gérer les administrateurs',
	firstName: 'Prénom',
	lastName: 'Nom',
	email: 'Adresse courriel',
	role: 'Rôle',
	description: 'Ajouter de nouveaux administrateurs ou gérer des administrateurs existants',
	noInformationPlaceholder: 'Aucune information disponible pour les options sélectionnées',
	updateAdminErrorToast: 'Échec de la mise à jour. Veuillez vérifier et réessayer plus tard.',
	updateAdminSuccessToast: 'Modifications enregistrées'
};

export const adminManageUsers = {
	title: 'Gérer les utilisateurs',
	description: 'Chercher un utilisateur par son identifiant global unique (GUI)',
	inputLabel: "Identifiant global unique (GUI) de l'utilisateur",
	searchButtonLabel: 'Rechercher',
	cancelButtonLabel: 'Effacer',
	errorMessage: "Entrer un identifiant global unique (GUI) valide pour l'utilisateur",
	userDetails: "Renseignements sur l'utilisateur",
	projects: 'Projets',
	delegates: 'Délégués',
	settings: 'Paramètres',
	noResultsPlaceholder: 'Aucun enregistrement trouvé',
	delegatedTo: 'Délégué à :',
	delegatedFrom: 'Délégué par :',
	gui: 'Identifiant global unique (GUI)',
	firstName: 'Prénom',
	lastName: 'Nom',
	emailAddress: 'Adresse courriel',
	projectName: 'Nom du projet',
	projectId: 'Identifiant du projet'
};

export const adminCommon = {
	save: 'Enregistrer',
	reset: 'Réinitialiser'
};
